module.exports = __webpack_public_path__ + "static/warning.d1c78503.svg";